import createHistory from 'history/createBrowserHistory'

// Usa PUBLIC_URL para el basename (configurado en .env.development o .env.production)
const basename = process.env.PUBLIC_URL || '/'

export default createHistory({ basename })


// WEBPACK FOOTER //
// ./src/utils/history.js